import React, { useEffect, useState } from 'react'
import { getImages } from './const'
import { Link } from 'react-router-dom'

const Footer = () => {
    const [isMobile, setIsMobile] = useState(false);
    const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
    };
    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
  return (
    <>
      {/* {console.log("isMobile", isMobile)} */}
        <footer className='footer-wrap'>
          <div className='container'>
            <div className='d-flex justify-content-between footer-block'>
              <div className='pe-md-4'>
                <div className='fb-logo mb-4'>
                  <img src={getImages('mm-logo-white.svg')}/>
                </div>
                {/* <div className='text-white mb-3'>140 Enterprise Parkway Boerne, TX 78006</div> */}
                <div className='fb-contact-info'>
                  <a href='tel:8309815050' className='d-flex align-items-center justify-content-between phone-no-text mb-2'>
                    <span className='fw-400 mnw-150'><span className='call-icon'><img src={getImages('call.png')} alt='call'/></span> Boerne:</span> 
                    <span>830-981-5050</span>
                  </a>
                  <a href='tel:5122337800' className='d-flex align-items-center justify-content-between phone-no-text mb-3'>
                    <span className='fw-400 mnw-150'><span className='call-icon'><img src={getImages('call.png')} alt='call'/></span> Austin:</span> 
                    <span>512-233-7800</span>
                  </a>
                  <a href='mailto:sales@themarkmotors.com' className='text-theme mt-1 d-inline-block'>sales@themarkmotors.com</a>
                </div>
                
                <div className='text-center text-md-start d-md-none'>
                  <div className='mt-2 d-inline-flex align-items-center text-white'>
                    <div className='xs-title fw-500 pe-1'>Payment Links:</div>&nbsp;
                    <a href='https://swipesimple.com/links/lnk_bdd74e8c' target='_blank' className='text-theme d-inline-block'><u>Boerne</u></a>
                    &nbsp; |  &nbsp;
                    <a href='https://swipesimple.com/links/lnk_bdd74e8c' target='_blank' className='text-theme d-inline-block'><u>Austin</u></a>
                  </div>
                </div>
              </div>
              <div className='d-none d-md-block'>
                {/* <div className='footer-title'>Navigation</div> */}
                <ul className='footer-menu pt-5 mt-3'>
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/cars-for-sale-boerne-tx">Inventory</Link>
                  </li>
                  <li>
                  <Link to='/trade-or-sell-exotic-car'>Sell My Exotic</Link>
                  </li>
                  <li>
                    <Link to="/financing">Finance</Link>
                  </li>
                </ul>
              </div>
              <div className='d-none d-md-block'>
                {/* <div className='footer-title'>About</div> */}
                <ul className='footer-menu pt-5 mt-3'>
                  <li>
                    <Link to="/schedule-car-maintenance-or-auto-repair-boerne-tx">Service Center</Link>
                  </li>
                  {/* <li>
                    <Link to='/custom'>Mark Customs</Link>
                  </li>
                  <li>
                    <Link to='/detailing'>Mark Detailing</Link>
                  </li> */}
                  <li className='w-100'>
                      <Link to='https://markcustomstx.com/' target='_blank'>Mark Customs</Link>
                  </li>
                  <li className='w-100'>
                      <Link to='https://markmotorsdetailing.com/' target='_blank'>Mark Motors Detailing</Link>
                  </li>
                  <li>
                    <Link to="/contact-mark-motors-in-boerne-tx">Contact Us</Link>
                  </li>
                </ul>
              </div>
              <div>
                {/* <div className='footer-title d-none d-md-block'>Stay Connected</div> */}
                <ul className='footer-menu pt-4 pt-md-5 mt-0'>
                  <li>
                    <a href='https://www.facebook.com/themarkmotors' target='_blank'><span className='social-icon'><img src={getImages('ico-facebook.svg')}/></span> <span className='d-none d-md-inline-block'>Facebook</span></a>
                  </li>
                  {/* <li>
                    <a href='#'><span className='social-icon'><img src={getImages('ico-twitter.svg')}/></span> <span className='d-none d-md-inline-block'>Twtiter</span></a>
                  </li> */}
                  <li>
                    <a href='https://www.instagram.com/markmotors_boerne/' target='_blank'><span className='social-icon'><img src={getImages('ico-instagram.svg')}/></span> <span className='d-none d-md-inline-block'>Instagram</span></a>
                  </li>
                </ul>
                <div className='mt-md-5 mt-3 powered-by text-md-end'>
                  {isMobile ? 
                    <a href='https://greenlightautomotivesolutions.com/' target='_blank'><img src={getImages('gas-horz.svg')}/></a>
                    :
                    <a href='https://swipesimple.com/links/lnk_aa65273bdfc85262b9f0ae4196052485' target='_blank'><img src={getImages('gas-vert.svg')}/></a>
                  }
                </div>
              </div>
            </div>
            <div className='text-center text-md-start d-none d-md-block'>
              <div className='mt-2 d-inline-flex align-items-center text-white'>
                <div className='xs-title fw-500 pe-1'>Payment Links:</div>&nbsp;
                <a href='https://swipesimple.com/links/lnk_bdd74e8c' target='_blank' className='text-theme d-inline-block'><u>Boerne</u></a>
                &nbsp; |  &nbsp;
                <a href='https://swipesimple.com/links/lnk_aa65273bdfc85262b9f0ae4196052485' target='_blank' className='text-theme d-inline-block'><u>Austin</u></a>
              </div>
            </div>
          </div>
        </footer>
    </>
  )
}

export default Footer